export class Controller {

    /** @ngInject */
    constructor(
        $state,
        AddNewSharedPasswordModal,
        ImportSharedPasswordsModal,
        ManageSharedPasswordModal,
        SharedAccountShare,
        ComputerAdministrationAccountShare,
    ) {
        this.$state = $state;
        this.AddNewSharedPasswordModal = AddNewSharedPasswordModal;
        this.ImportSharedPasswordsModal = ImportSharedPasswordsModal;
        this.ManageSharedPasswordModal = ManageSharedPasswordModal;
        this.SharedAccountShare = SharedAccountShare;
        this.ComputerAdministrationAccountShare = ComputerAdministrationAccountShare;
    }

    $onInit() {
    }

    isComputerAdministrationAccount(account) {
        return account.publicService.serviceName == 'ComputerLocalAccountAdministration';
    }


    showManageModal(account) {
        this.ManageSharedPasswordModal(account).then(() => this.$state.reload(this.$state.current));
    }

    showAddModal() {
        this.publicServicesWithSso$.get()
            .then(items => this.AddNewSharedPasswordModal(items))
            .then(account => this.accounts.push(account))
    }

    showImportModal() {
        this.ImportSharedPasswordsModal().then(accounts => this.accounts.push(...accounts));
    }

    showShareModal(account) {
        if (this.isComputerAdministrationAccount(account)) {
            this.ComputerAdministrationAccountShare(account);
        } else {
            this.SharedAccountShare(account);
        }

    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/shared-passwords.controller.js